import { firestore, collections } from "@/configs/firebase";

export type SaleStatusName = "sale" | "pending" | "post_date" | "failed";
export type VerificationStatusName =
  | "sent"
  | "received"
  | "requested"
  | "stopped"
  | "started";

export type VerificationType = "esig_email" | "esig_text" | "voice";
export type LeadEventTypes = "verification_status" | "sale_status";
export type ProductGroup =
  | "niia_health"
  | "insurita_ancillary"
  | "discount_plan";

export enum ProductGroups {
  NIIA_HEALTH = "niia_health",
  INSURITA_ANCILLARY = "insurita_ancillary",
  DISCOUNT_PLAN = "discount_plan"
}

export type SaleStatus = {
  event_type: LeadEventTypes;
  name: SaleStatusName;
  group: ProductGroup;
  created_ts: firestore.Timestamp;
  user_email: string;
  reason?: string;
  post_date?: firestore.Timestamp | string;
  effective_date?: firestore.Timestamp;
};

export type VerificationStatus = {
  event_type: LeadEventTypes;
  name: VerificationStatusName;
  verification_type: VerificationType;
  group: ProductGroup;
  created_ts: firestore.Timestamp | string;
  user_email: string;
  snipped_recording_key?: string;
};

class LogEvent {
  saleStatus(
    leadId: string,
    status: SaleStatus
  ): Promise<firestore.DocumentData> {
    return collections.lead
      .doc(leadId)
      .collection("event")
      .add(status);
  }

  verificationStatus(
    leadId: string,
    status: VerificationStatus
  ): Promise<firestore.DocumentData> {
    return collections.lead
      .doc(leadId)
      .collection("event")
      .add(status);
  }
}

export default new LogEvent();
